import { RouteConfig } from 'vue-router'

const route: RouteConfig[] = [
  {
    path: '/tuition',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/TuitionTracker/Index.vue'),
        children: [
          {
            path: ':studentId',
            component: () => import('pages/TuitionTracker/Detail.vue')
          }
        ]
      }
    ],
    meta: { forParent: true }
  }
]

export default route
